export default __webpack_public_path__ + "static/media/bank-account-icon.a2849413.svg";